<img hisImage="email" alt="{{'cm.stu.email'|hisUi}}" title="{{'cm.stu.email'|hisUi}}" class="inlineicon">
<a href="mailto:{{value}}">{{value}}</a>

